import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { useRouter } from 'next/router'
import WifButton from '../WifButton'

const EmptyCart: React.FC = () => {
  const { t } = useTranslation()
  const router = useRouter()
  return (
    <div className='flex flex-col max-w-[300px] mx-auto text-center'>
      <h2 className='text-xl font-normal font-quicksand mt-20'>{t('cart:Cart_Empty_Title')}</h2>
      <div className='my-[30px]'>
        <Image src='/images/empty_cart.svg' alt='Empty Cart Image' width={138} height={119} />
      </div>
      <p className='font-light text-sm mb-[30px]'>{t('cart:Cart_Empty_Description')}</p>
      <WifButton
        id='cart-explore-button'
        text={t('common:Word_Explore')}
        handleClick={() => router.push('/explore')}
      />
    </div>
  )
}

export default EmptyCart
